export enum TransactionIntent {
  Unknown = 'Unknown',
  NotSure = 'NotSure',
  Sell = 'Sell',
  Trade = 'Trade'
}

export enum LifeCycleState {
  Active = 'Active',
  AppliedToPurchase = 'AppliedToPurchase', // Treat like Active
  Complete = 'Complete',
  Expired = 'Expired',
  Manual = 'NeedsManualAppraisal',
  Rejected = 'Rejected', // Treat like Manual
  Replaced = 'Replaced',
  Scheduled = 'Scheduled' // Treat like Active
}

export type AcquisitionVehicle = {
  color: string;
  make: string;
  model: string;
  trim: string;
  year: number;
};

export type AcquisitionsErrors = {
  message: string;
  locations: Array<{ line: number; column: number }>;
  path: string[];
  extensions: Record<any, any>;
};

export type TradeInPreviewAcquisition = {
  daysToExpiration: number | null;
  id: string;
  isAlmostExpired: boolean | null;
  lifeCycleState: LifeCycleState;
  offerAmount: number;
  transactionIntent: TransactionIntent;
  vehicle: AcquisitionVehicle;
  equity: number;
  lien: {
    tenDayPayoff: {
      amount: number;
    };
  };
};

export type TradeInPreviewAcquisitionsApiResponse = {
  errors?: AcquisitionsErrors[];
  data: { tradeInPreviewAcquisitions: TradeInPreviewAcquisition[] | null };
};

export default TradeInPreviewAcquisition;
